import { useEffect, useState } from 'react'
import { SITE_ACTIONS } from '../constants/site-actions'

export function useBackToTop() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    function onScroll() {
      setVisible(window.scrollY >= SITE_ACTIONS.showAfterPx)
    }

    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  function scrollToTop() {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }

  return { visible, scrollToTop }
}
